<template>
  <div class="page_not-found">
    <div class="page__container">
      <h1>Ошибка 404</h1>
      <p>Возможно, такой страницы не существует</p>
      <div>
        <button class="btn btn-lg btn-success" @click="handleClick">
          Вернуться на главную
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$router.push('/');
    },
  },
}
</script>

<style scoped>
.page_not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
.page_not-found .page__container {
  text-align: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/_shared/layouts/PageNotFoundLayout.vue